import * as Icons from '@ant-design/icons'
import { createElement } from 'react'
import type { ReactNode } from 'react'

/** 图标名称 → 组件映射（与数据库 sys_menu.icon 字段对应）
 *  自动从 @ant-design/icons 中查找，无需手动注册每个图标
 */
const iconMap: Record<string, ReactNode> = {}

/** 根据图标名称获取图标组件（动态查找，新增菜单图标无需修改此文件） */
export const getIcon = (name: string): ReactNode => {
  if (iconMap[name]) return iconMap[name]
  const IconComponent = (Icons as Record<string, unknown>)[name]
  if (typeof IconComponent === 'object' || typeof IconComponent === 'function') {
    const node = createElement(IconComponent as React.ComponentType)
    iconMap[name] = node
    return node
  }
  return null
}

/** 获取所有可用的图标名称列表（菜单管理下拉选择用） */
export const getIconNames = (): string[] => {
  return Object.keys(Icons).filter((name) => name.endsWith('Outlined'))
}

export default iconMap
